import { Amount, Currency } from "@goodfill/domain-properties";
import { formatCurrencyAmount } from "@goodfill/format-number";
import React from "react";

export const formatBondBalanceAccount = (props: { value: Amount; currency: Currency }) =>
  formatCurrencyAmount({
    value: props.value.toFixed(0),
    numDecimals: 0,
    currency: props.currency,
  });

export const BalanceAccountAmountComponent = (props: {
  value: Amount | undefined;
  currency: Currency;
}) => (
  <>
    {props.value != null
      ? formatBondBalanceAccount({
          value: props.value,
          currency: props.currency,
        })
      : null}
  </>
);
